import React from 'react';
// Components
import { App } from './App';
// Context
import { Web3ContextProvider } from './context/web3.context';
// Styles
import './assets/styles/main.scss';
export const NumismeApp = () => (React.createElement(Web3ContextProvider, null,
    React.createElement(App, null)));
